import React from 'react'

// Флаги языков генерации - те же, что были в старом переключателе (components/Button, иконки RU/EN/SA).
const LangFlag = ({ lang }) => {
  if (lang === 'RU')
    return (
      <svg width="20" height="14" viewBox="0 0 25 18" aria-hidden="true" style={{ borderRadius: 2, flex: 'none' }}>
        <rect x="0" y="0" width="25" height="6" fill="white" />
        <rect x="0" y="6" width="25" height="6" fill="#0F56E0" />
        <rect x="0" y="12" width="25" height="6" fill="#D22222" />
        <rect x="0.25" y="0.25" width="24.5" height="17.5" fill="none" stroke="rgba(0,0,0,.15)" strokeWidth="0.5" />
      </svg>
    )
  if (lang === 'EN')
    return (
      <svg width="20" height="14" viewBox="0 0 25 18" aria-hidden="true" style={{ borderRadius: 2, flex: 'none' }}>
        <rect width="25" height="18" fill="#00247D" />
        <polygon points="0,0 25,18 22,18 0,2" fill="white" />
        <polygon points="25,0 0,18 3,18 25,2" fill="white" />
        <polygon points="0,0 25,18 21,18 0,3" fill="#CF142B" />
        <polygon points="25,0 0,18 4,18 25,3" fill="#CF142B" />
        <rect x="10" width="5" height="18" fill="white" />
        <rect y="7" width="25" height="4" fill="white" />
        <rect x="11" width="3" height="18" fill="#CF142B" />
        <rect y="8" width="25" height="2" fill="#CF142B" />
      </svg>
    )
  if (lang === 'SA')
    return (
      <svg width="20" height="14" viewBox="0 0 25 18" aria-hidden="true" style={{ borderRadius: 2, flex: 'none' }}>
        <rect x="0" y="0" width="25" height="12" fill="#009DFE" />
        <rect x="0" y="15" width="25" height="3" fill="#009B01" />
        <rect x="0" y="13" width="25" height="2" fill="#FE0201" />
        <rect x="0" y="11" width="25" height="2" fill="white" />
        <circle cx="12.5" cy="5" r="3.5" fill="white" />
      </svg>
    )
  return null
}

export const LANG_NAME = { RU: 'Русский', EN: 'Английский', SA: 'Якутский (саха)' }

export default LangFlag
